import React, { forwardRef } from 'react';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { Confirmation } from 'components/common';

const DeleteSubUserAction = forwardRef((props: any, ref: any) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleDelete = async () => {
    try {
      await dataProvider.delete('deleteOrEditMember', {
        tenantId: props.tenantId,
        memberId: props.record.id,
      });

      refresh();
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    }
  };

  return (
    <Confirmation title="Delete sub-user" content="Are you sure you want to delete sub-user?">
      <MenuItem ref={ref} onClick={handleDelete}>
        Delete
      </MenuItem>
    </Confirmation>
  );
});

export default DeleteSubUserAction;
